import {
  CancelOrderOutput,
  CancelOrderSelfServeInput,
} from "@redotech/redo-model/order-editing/schemas/cancel-order";

export const cancelOrderSelfServe = {
  name: "cancelOrderSelfServe" as const,
  input: CancelOrderSelfServeInput,
  output: CancelOrderOutput,
};
